import { render } from "./Propriedade.vue?vue&type=template&id=954e2d12"
import script from "./Propriedade.vue?vue&type=script&lang=js"
export * from "./Propriedade.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./Propriedade.vue?vue&type=style&index=1&id=954e2d12&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__